import { defineMessages, useIntl } from 'react-intl';

import { FlatIconButton } from '@packages/shared/src/components/FlatIconButton/FlatIconButton';
import { useIsHydrated } from '@packages/shared/src/hooks/useIsHydrated/useIsHydrated';
import { BurgerText32 } from '@packages/themes/icons';

export type HamburgerButtonProps = {
  onClick: () => void;
};

const messages = defineMessages({
  primaryNavigationHamburgerIcon: {
    id: 'primary.navigation.hamburger.icon.label',
    defaultMessage: 'Navigation öffnen',
  },
});
export const HamburgerButton = ({ onClick }: HamburgerButtonProps) => {
  const { isHydrated } = useIsHydrated();
  const { formatMessage } = useIntl();

  return (
    <FlatIconButton
      sx={{
        margin: 0,
        paddingX: 1,
        display: {
          lg: 'none',
        },
      }}
      aria-label={formatMessage(messages.primaryNavigationHamburgerIcon)}
      onClick={onClick}
      disabled={!isHydrated}
    >
      <BurgerText32 />
    </FlatIconButton>
  );
};
